import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import { DRIVER_ROLE_ID } from "@/services/consts/account";
import { OPERATION_OFFICE_TYPE } from "@/services/consts";
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccountResponse from '@/types/responses/getAccount';
import getDepartmentResponse from '@/types/responses/getDepartment';
import getAccountsType from "@/types/requests/getAccounts";
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';


export default /*@__PURE__*/_defineComponent({
  __name: 'DriverAutoComplete',
  props: {
    modelValue: {},
    selectedDepartment: {},
    initialItemId: {},
    managementOffice: {},
    operationOffices: {},
    errorMessages: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "isDriverLoading"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<getAccountResponse[]>([]);
const isLoading = ref<boolean>(true);

onMounted(() => {
  const params: getAccountsType = {
    officeable_type: OPERATION_OFFICE_TYPE,
    role_id: DRIVER_ROLE_ID
  }
  if(props.operationOffices && props.operationOffices.length > 0) {
    params.type_class = OPERATION_OFFICE_TYPE,
    params.officeable_id = props.operationOffices[0].id
  }
  Api()
    .autoCompleteAccounts(params)
    .then((data) => {
      items.value = data;
      isLoading.value = false
      emit("isDriverLoading", false);
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const filteredByDepartment = computed(() => {
  if (!props.selectedDepartment) return items.value
  return items.value.filter(item => item.department_id === props.selectedDepartment?.id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: "ドライバー",
    itemName: "name",
    items: filteredByDepartment.value,
    "initial-item-id": __props.initialItemId,
    "management-office": __props.managementOffice,
    "operation-offices": __props.operationOffices,
    "error-messages": __props.errorMessages,
    disabled: __props.disabled
  }, null, 8, ["modelValue", "items", "initial-item-id", "management-office", "operation-offices", "error-messages", "disabled"]))
}
}

})